import { IAddUpdateDeleteObject, IPopupObject } from 'constants/interfaces/GlobalInterfaces';

// New Interfaces
export interface IAudienceListAction {
  type: string;
  payload: { [key: number | string]: string | string[] | boolean | number | number[] | IListItem[] | IListItem | IListItemNames[] | IListItemNames };
  message: string;
}

export interface IAudienceListState {
  lists: IListItem[];
  totalLists: number;
  totalSearchedLists: number;
  loading: boolean;
  listAlreadyExists: boolean;
  page: number;
  message: string;
  success: boolean;
  searchTerm: string;
  searchedLists: IListItem[];
  searchedLoading: boolean;
  searchedPage: number;
  addNewList: IAddUpdateDeleteObject;
  editList: IAddUpdateDeleteObject;
  deleteList: IAddUpdateDeleteObject;
  cloneList: IAddUpdateDeleteObject;
  exportPopup: IPopupObject;
  isListSelected: boolean;
  listsDataNamesLoading: boolean;
  listsDataNames: IListItemNames[];
}

export interface IListItemNames {
  listId: number;
  listName: string;
}

export interface IListItem {
  campaignName: string[];
  campaignsCount: number;
  createdBy: string;
  isActive: number;
  isCampaign: boolean;
  lastUpdated: string;
  lastUsedBy: string;
  listId: number;
  listName: string;
  topContactsPersonIds: number[];
  topContactsThumbnails: string[];
  totalClicks: number;
  totalContacts: number;
  totalSent: number;
}

export interface IListsResponse {
  success: boolean;
  message: string;
  data: IDataLists[];
}

export interface IDataLists {
  lists: IListItem[];
  totalLists: number;
}
export interface ICloneListResponse {
  success: boolean;
  message: string;
  data: [
    {
      listDetail: IContactItem;
    },
  ];
}

export interface IAudienceAPIError {
  message: string;
}

//* *****************************************
//* ***** LIST CONTACTS/LIST DETAILS  *******
//* *****************************************

export interface IAudienceListDetailsAction {
  type: string;
  payload: { [key: number | string]: string | boolean | number | number[] | string[] | IContactItem[] | IContactItem };
}
export interface IAudienceListContactsState {
  listId: number;
  listName: string;
  prevListName: string;
  message: string;
  success: boolean;
  loading: boolean;
  listContacts: Array<IContactItem>;
  searchTerm: string;
  totalContacts: number;
  page: number;
  searchedlistContacts: Array<IContactItem>;
  searchedLoading: boolean;
  searchedPage: number;
  totalSearchedContacts: number;
  selectedContacts: Array<IContactItem>;
  allContactsSelected: boolean;
  openListLoading: boolean;
  deleteContact: IAddUpdateDeleteObject;
  editListName: IAddUpdateDeleteObject;
  reloadListContacts: boolean;
  addNewContact: IAddUpdateDeleteObject;
  editContact: IAddUpdateDeleteObject;
  isSorted: boolean;
}
export interface IContactItem {
  alreadyExistsInList: boolean;
  color: string;
  companyWebsite: string;
  contactEmail: string;
  contactId: number;
  contactName: string;
  designation: string;
  engagementScore: number;
  firstName: string;
  fullName: string;
  industry: string | null;
  isActive: number;
  isListContact: boolean;
  lastName: string;
  linkedinUrl: string;
  organization: string;
  personality: string;
  phoneNumber: string;
  status: string;
  thumbnail: string;
  twitterUrl: string;
}

export interface IResponseObject {
  success: boolean;
  message: string;
}
export interface IListContactsResponse extends IResponseObject {
  data: Array<IDataListContacts>;
}

export interface IDataListContacts {
  contacts: Array<IContactItem>;
  totalContacts: number;
  listName: string;
}

export interface IListContactParams {
  [key: number | string]: string | boolean | number | string[];
}

export enum FooterActionsEnum {
  ADD_TO_LIST = 'ADD_TO_LIST',
  REMOVE_FROM_LIST = 'REMOVE_FROM_LIST',
  REMOVE_CONTACT = 'REMOVE_CONTACT',
  DELETE_CONTACT = 'DELETE_CONTACT',
}
